import { Button, Stack, Typography } from "@mui/material";
import { BuilderTranslate } from "./types";

/** Uma barra, uma ação primária: "Salvar" no editor, "Nova view" na lista. */
export default function BuilderToolbar({ title, editing, dirty, saving, busy = false, previewOpen, onBack, onSave, onNew, onTogglePreview, tr }: {
    title: string; editing: boolean; dirty: boolean; saving: boolean; busy?: boolean; previewOpen?: boolean;
    onBack: () => void; onSave: () => void; onNew: () => void; onTogglePreview?: () => void; tr: BuilderTranslate;
}) {
    return <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ sm: "center" }} gap={2} sx={{ mb: 2, minWidth: 0 }}>
        <Typography variant="h5" component="h1" sx={{ overflowWrap: "anywhere", minWidth: 0 }}>{title}</Typography>
        <Stack direction="row" gap={1} flexShrink={0} flexWrap="wrap">
            {editing ? <>
                <Button variant="text" color="inherit" onClick={onTogglePreview} aria-pressed={previewOpen}>{previewOpen ? tr("hide_preview", "Hide preview") : tr("show_preview", "Show preview")}</Button>
                <Button variant="outlined" onClick={onBack}>{tr("back", "Back to views")}</Button>
                <Button variant="contained" disabled={!dirty || saving} onClick={onSave}>{saving ? tr("saving", "Saving…") : tr("save", "Save")}</Button></>
                : <Button variant="contained" disabled={busy} onClick={onNew}>{tr("new", "New view")}</Button>}
        </Stack>
    </Stack>;
}
